// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1khIZ","label":"styles_label__6SXt0"};